(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-read-more-wrapper]').forEach(function(wrapper) {
    wrapper.setAttribute('data-collapsed', '');
    var toggle = wrapper.querySelector('[data-read-more-toggle]');
    toggle.addEventListener('click', function() {
      if (wrapper.hasAttribute('data-collapsed')) {
        wrapper.removeAttribute('data-collapsed');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        wrapper.setAttribute('data-collapsed', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
